import { render, staticRenderFns } from "./PerspectiveFab.vue?vue&type=template&id=e9d718c4&lang=pug&"
import script from "./PerspectiveFab.vue?vue&type=script&lang=js&"
export * from "./PerspectiveFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PerspectiveFab.vue"
export default component.exports